import cn from 'clsx'
import { rem } from 'polished'
import React from 'react'
import styled from 'styled-components'

import noop from 'lib/function/noop'
import zIndex from 'styles/tools/z-index'

const Container = styled.div`
  position: absolute;
  z-index: ${zIndex.modal};
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.2s;
  max-width: ${rem(280)};
  pointer-events: all;

  &.above {
    left: 50%;
    top: ${rem(-16)};

    &.alignment-left {
      transform: translateY(-100%) translateX(0);
      left: calc(50% - 28px);
    }

    &.alignment-right {
      transform: translateY(-100%) translateX(-100%);
      left: calc(50% + 28px);
    }

    &.alignment-center {
      transform: translateY(-100%) translateX(-50%);
    }
  }

  &.above-left {
    left: 0;
    top: ${rem(-16)};

    &.alignment-left {
      transform: translateY(-100%);
    }
  }

  &.below {
    left: 50%;
    bottom: ${rem(-16)};

    &.alignment-left {
      transform: translateY(100%) translateX(0);
      left: calc(50% - 28px);
    }

    &.alignment-right {
      transform: translateY(100%) translateX(-100%);
      left: calc(50% + 28px);
    }

    &.alignment-center {
      transform: translateY(100%) translateX(-50%);
    }
  }

  &.below-left {
    left: 0;
    bottom: ${rem(-16)};

    &.alignment-left {
      transform: translateY(100%) translateX(0);
    }
  }

  &.left {
    left: ${rem(-16)};
    top: 50%;

    &.alignment-center {
      transform: translateY(-50%) translateX(-100%);
    }
  }

  &.open {
    opacity: 1;
    transition: opacity 0.2s;
    visibility: visible;
  }
`

export type WindowAlignments = 'left' | 'right' | 'center'
export type WindowPositions =
  | 'above'
  | 'above-left'
  | 'below'
  | 'below-left'
  | 'left'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  alignment?: WindowAlignments
  position?: WindowPositions
  open?: boolean
  width?: number
  verticalOffset?: number
}

const MapInfoWindow = React.forwardRef<HTMLDivElement, Props>((props, ref) => {
  const {
    className,
    onClick = noop,
    children,
    position = 'above',
    open,
    alignment = 'center',
    style,
    width,
    ...rest
  } = props

  const onClickIntercept = (e: React.MouseEvent<HTMLDivElement>) => {
    onClick?.(e)
  }

  return (
    <Container
      {...rest}
      ref={ref}
      onClick={onClickIntercept}
      style={{ ...style, width }}
      className={cn(className, position, `alignment-${alignment}`, { open })}
    >
      {children}
    </Container>
  )
})

MapInfoWindow.displayName = 'MapInfoWindow'

export default React.memo(MapInfoWindow)
